@if (actualite) {
  <section class="container-background container-fluid content">
    <div class="row">
      <h2 class="page-title col-12">{{actualite.titre}} - <small>{{actualite.date | date:'dd/MM/y'}}</small></h2>
    </div>
    <div class="m-2 p-4 mb-5 bg-white rounded">
      <swiper-container
        class="shadow carousel-images"
        slides-per-view="1"
        loop="true"
        [speed]="carouselSpeed"
        [pagination]="actualite.images.length > 1"
        pagination-clickable="true">
        @for (image of actualite.images; track image) {
          <swiper-slide>
            <app-cover [image]="image.url" [shadow]="false"></app-cover>
          </swiper-slide>
        }
      </swiper-container>
      <div class="mt-4" [innerHTML]="content"></div>
    </div>
    @if (extraRouter.previousUrl) {
      <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-bottom justify-content-center">
        <a class="btn btn-light" [routerLink]="extraRouter.previousUrl">Fermer</a>&nbsp;
      </nav>
    }
  </section>
}
